<div class="w-full flex flex-col h-full support-ticket-container">
  <form *ngIf="supportTicketForm" [formGroup]="supportTicketForm" (ngSubmit)="onSubmit()" class="flex flex-col h-full">
    <!-- Scrollable Content Area -->
    <div #scrollableContent class="flex-1 overflow-y-auto space-y-4 support-ticket-content">
      <div>
        <label for="name" class="font-semibold block text-sm text-gray-700 mb-2">
          Customer Name <span class="text-danger ml-1">*</span>
        </label>
        <input pInputText id="name" formControlName="name" placeholder="Enter your full name"
          class="w-full border border-gray-300 rounded-base p-3 text-sm placeholder-gray-500" />
        <small *ngIf="isFieldInvalid('name')" class="block text-danger text-xs mt-1">
          {{ getFieldError('name') | titlecase }}
        </small>
      </div>

      <div>
        <label for="company" class="font-semibold block text-sm text-gray-700 mb-2">
          Company Name <span class="text-danger ml-1">*</span>
        </label>
        <input pInputText id="company" formControlName="company" placeholder="Enter your company name"
          class="w-full border border-gray-300 rounded-base p-3 text-sm placeholder-gray-500" />
        <small *ngIf="isFieldInvalid('company')" class="block text-danger text-xs mt-1">
          {{ getFieldError('company') | titlecase }}
        </small>
      </div>

      <div>
        <label for="email" class="font-semibold block text-sm text-gray-700 mb-2">
          Email Address <span class="text-danger ml-1">*</span>
        </label>
        <input pInputText id="email" formControlName="email" placeholder="Enter your email address"
          class="w-full border border-gray-300 rounded-base p-3 text-sm placeholder-gray-500" />
        <small *ngIf="isFieldInvalid('email')" class="block text-danger text-xs mt-1">
          {{ getFieldError('email') | titlecase }}
        </small>
      </div>

      <div>
        <label for="email" class="font-semibold block text-sm text-gray-700 mb-2">
          Title <span class="text-danger ml-1">*</span>
        </label>
        <input pInputText id="title" formControlName="title" placeholder="Enter your title"
          class="w-full border border-gray-300 rounded-base p-3 text-sm placeholder-gray-500" />
        <small *ngIf="isFieldInvalid('title')" class="block text-danger text-xs mt-1">
          {{ getFieldError('title') | titlecase }}
        </small>
      </div>

      <div>
        <label for="description" class="font-semibold block text-sm text-gray-700 mb-2">
          Description <span class="text-danger ml-1">*</span>
        </label>
        <textarea pInputTextarea id="description" formControlName="description"
          placeholder="Please provide detailed information about your issue or request..." rows="4"
          class="w-full border border-gray-300 rounded-base p-3 text-sm placeholder-gray-500 resize-vertical"></textarea>
        <small *ngIf="isFieldInvalid('description')" class="block text-danger text-xs mt-1">
          {{ getFieldError('description') | titlecase }}
        </small>
      </div>

      @if(attachmentFiles.length > 0) {
      <div class="space-y-3">
        <div class="flex justify-between items-center">
          <p class="text-sm text-gray-600">Attachments ({{ attachmentFiles.length }})</p>
          <app-button label="Remove All" (clicked)="clearAllAttachments()" variant="outlined" severity="contrast" />
        </div>

        <div class="grid grid-cols-2 gap-3">
          @for(attachment of attachmentPreviews; track $index) {
          <div class="border rounded-lg p-2 bg-gray-50 relative">
            <div (click)="removeAttachment($index)"
              class="absolute top-1 right-1 w-5 h-5 flex items-center justify-center rounded-full bg-gray-400 hover:bg-gray-500 text-white transition-colors cursor-pointer z-10">
              <app-icon [type]="'x'" [source]="'lucide'" [size]="'sm'" [class]="'text-white'" />
            </div>
            <div class="flex flex-col items-center space-y-2">
              @if(attachment.isImage) {
              <img [src]="attachment.preview" alt="Attachment Preview" class="w-16 h-16 object-cover rounded border" />
              } @else if(attachment.isVideo) {
              <div class="w-16 h-16 flex items-center justify-center bg-gray-100 rounded border text-2xl">
                🎥
              </div>
              } @else {
              <div class="w-16 h-16 flex items-center justify-center bg-gray-100 rounded border text-2xl">
                {{ attachment.preview }}
              </div>
              }
              <p class="text-xs text-gray-600 text-center truncate w-full" [title]="attachment.file.name">
                {{ attachment.file.name }}
              </p>
            </div>
          </div>
          }
        </div>
      </div>
      }
    </div>

    <div class="flex-col border-gray-200 bg-white space-y-3 support-ticket-footer">
      <input #fileInput type="file"
        accept="image/*,.png,.jpg,.jpeg,.gif,.bmp,.webp,.pdf,.doc,.docx,.xls,.xlsx,.mp4,.avi,.mov,.wmv,.mkv,.gif,.webm"
        style="display: none;" (change)="onFileSelected($event)" multiple />

      <app-button label="Upload Attachments" (clicked)="triggerFileInput()" variant="outlined" severity="contrast"
        [fullWidth]="true" />

      <app-button type="submit" label="Submit Ticket" [loading]="isSubmitting" (clicked)="onSubmit()" [fullWidth]="true"
        [disabled]="isSubmitting || !supportTicketForm.valid" variant="filled" severity="primary" class="mt-2" />
    </div>
  </form>
</div>